// ACC (Alpine Club of Canada) booking strategy — Mews-backed.
//
// This module is the source of truth for the Mews reserve URL shape.
// `utils/availabilityRequest.js` re-exports `buildMewsReserveUrl` from
// here for legacy callers (tests) that imported it by name.

import { add, format } from "date-fns";
import { resolveMinStayLength, resolveMinCapacity } from "./_context.js";

/**
 * Build a Mews-distributor reserve URL for a site on a specific stay.
 * Encodes mewsStart / mewsEnd / mewsAdultCount as query params.
 */
export function buildMewsReserveUrl(
  site,
  { startDate, minStayLength, minCapacity = 1 },
) {
  const url = new URL(site.reserveUrl);
  url.searchParams.set("mewsStart", format(startDate, "yyyy-MM-dd"));
  url.searchParams.set(
    "mewsEnd",
    format(add(startDate, { days: minStayLength }), "yyyy-MM-dd"),
  );
  url.searchParams.set("mewsAdultCount", String(minCapacity));
  return url.toString();
}

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    return buildMewsReserveUrl(site, {
      startDate: arrivalDate,
      minStayLength: resolveMinStayLength(ctx),
      minCapacity: resolveMinCapacity(ctx),
    });
  },

  // ACC has no map / preview page — each Mews "site" is a single hut
  // category, not a multi-site campground. Suppress the alert.
  buildPreviewUrl() {
    return null;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as mewsStart=YYYY-MM-DD.",
        },
        departureDate: {
          status: "required",
          notes: "Encoded as mewsEnd=YYYY-MM-DD.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already identifies the Mews property.",
        },
        partySize: {
          status: "optional",
          defaultValue: 1,
          notes: "Encoded as mewsAdultCount; defaults to 1 when omitted.",
        },
      },
    };
  },
};
